export const stylesDropArea: React.CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "11px",
  borderWidth: 1,
  borderRadius: 4,
  borderColor: "rgba(230, 241, 242, 0.4)",
  borderStyle: "dashed",
  backgroundColor: "rgba(21, 33, 37, 1)",
  outline: "none",
  cursor: "pointer",
};

export const acceptStyle: React.CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "11px",
  borderWidth: 1,
  borderRadius: 4,
  borderColor: "rgba(57, 172, 200, 0.1)",
  borderStyle: "solid",
  backgroundColor: "rgba(19, 27, 32, 1)",
  outline: "none",
};

export const rejectStyle: React.CSSProperties = {
  borderColor: "red",
};
